import { sum } from 'ramda';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deepPropertyCount = (object: unknown): number => {
  if (Array.isArray(object)) return sum(object.map(deepPropertyCount));

  if (typeof object === 'object' && object != null)
    return sum(Object.values(object).map(deepPropertyCount));

  return 1;
};
